import { useEffect, useState } from "react";
import {
    getBlogs,
    getBlogsByCategory
} from "../../services/productService";

import { useNavigate } from "react-router-dom";

import "./BlogsPage.css";

function BlogsPage() {

    const navigate = useNavigate();

    const categories = [
        "Nutritional Benefits",
        "Recipe",
        "Press Release",
        "Breaking the Myths",
        "Smart Snacking Tips",
        "Gift Ideas"
    ];

    const [activeTab, setActiveTab] =
        useState("Nutritional Benefits");

    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        loadBlogs(activeTab);
    }, [activeTab]);

    const loadBlogs = async (category) => {

        try {

            const response =
                await getBlogsByCategory(category);

            setBlogs(response);

        } catch (error) {
            console.error(error);
        }
    };

    return (

        <section className="blogs-page">

            <h1 className="blogs-heading">
                Blogs
            </h1>

            <div className="blogs-tabs">

                {categories.map(category => (

                    <button
                        key={category}
                        className={
                            activeTab === category
                                ? "tab active"
                                : "tab"
                        }
                        onClick={() =>
                            setActiveTab(category)
                        }
                    >
                        {category}
                    </button>

                ))}

            </div>

            <div className="blogs-grid">

                {blogs.map(blog => (

                    <div
                        key={blog.id}
                        className="blog-card"
                    >

                        <img
                            src={blog.imageUrl}
                            alt={blog.title}
                        />

                        <div className="blog-content">

                            <h3>
                                {blog.title}
                            </h3>

                            <div className="blog-date">
                                {blog.publishedDate}
                            </div>

                            <p>
                                {blog.description}
                            </p>

                            <button
                                className="read-more-btn"
                                onClick={() =>
                                    navigate(
                                        `/blog/${blog.slug}`
                                    )
                                }
                            >
                                Read More
                            </button>

                        </div>

                    </div>

                ))}

            </div>

        </section>

    );
}

export default BlogsPage;